import baseApi from "./base"
import { Apply1Request, Apply1Response } from "./types/apply"
import { Apply2Request, Apply2Response, ResendOtpRequest, ResendOtpResponse } from "./types/apply2"
import { Apply3Request, Apply3Response } from "./types/apply3"
import { Apply4Request, Apply4Response } from "./types/apply4"
import { PreApply1Request, PreApply1Response } from "./types/preApply1"
import { EducationStatusRequest, EducationStatusResponse } from "./types/education"
import {
  WorkTypeRequest,
  WorkTypeResponse,
  OccupationRequest,
  OccupationResponse,
  ActivityAreaRequest,
  ActivityAreaResponse,
  JobTitleRequest,
  JobTitleResponse
} from "./types/job"
import { GetCitiesResponse } from "./types/city"
import { GetBranchesRequest, GetBranchesResponse } from "./types/branch"
import { RefreshCaptcha1Request, RefreshCaptcha1Response } from "./types/refreshCaptcha"
import { BaseResponse } from "./types/common"
import { GetCaptcha1Response, GetCaptcha1Request } from "./types/captcha"
import { GetProductInfoRequest, GetProductInfoResponse } from "./types/productInfo"
import { GetConfigResponse } from "./types/config"

const functionCode = "BKR0007"
const errorCounter = "3"
const lockHours = "24"

const api = baseApi.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    getProductInfo: builder.mutation<GetProductInfoResponse, GetProductInfoRequest>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          urunTip: body.urunTip,
          NextTransactionUrl: "Facebook/WebKonut/ProductDetail1",
          TokenSessionId: "ABCDEFABCDEFABCDEFABCDEFABCDEFABCDEF"
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getTokenByTckn1: builder.mutation<BaseResponse, string>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body,
          functionCode: functionCode,
          NextTransactionUrl: "Facebook/SocialMediaPortalCreateSession/GetTokenByTckn1",
          TokenSessionId: "ABCDEFABCDEFABCDEFABCDEFABCDEFABCDEF"
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getCaptcha: builder.mutation<GetCaptcha1Response, GetCaptcha1Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body.tckn,
          TokenSessionId: body.TokenSessionId,
          functionCode: functionCode,
          NextTransactionUrl: "Facebook/WebKonut/GetCaptcha1"
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    refreshCaptcha: builder.mutation<RefreshCaptcha1Response, RefreshCaptcha1Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body.tckn,
          functionCode: functionCode,
          NextTransactionUrl: "Facebook/WebKonut/RefreshCaptcha1",
          TokenSessionId: body.TokenSessionId
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    apply1: builder.mutation<Apply1Response, Apply1Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body.tckn,
          dogumGun: body.dogumGun,
          dogumAy: body.dogumAy,
          dogumYil: body.dogumYil,
          cepTel: body.cepTel,
          captcha: body.captcha,
          kvkkOnay: body.kvkkOnay,
          callCenter: body.callCenter,
          vade: body.vade,
          tutar: body.tutar,
          urunTip: body.urunTip,
          cid: body.cid,
          appCode: functionCode,
          errorCount: errorCounter,
          lockHours: lockHours,
          NextTransactionUrl: "Facebook/WebKonut/Apply1",
          TokenSessionId: body.TokenSessionId
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    apply2: builder.mutation<Apply2Response, Apply2Request>({
      query: (body) => ({
        url: "/",
        method: "POST",
        body: {
          tckn: body.tckn,
          otp: body.otp,
          NextTransactionUrl: "Facebook/WebKonut/Apply2",
          TokenSessionId: body.TokenSessionId
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    resendOtp: builder.mutation<ResendOtpResponse, ResendOtpRequest>({
      query: (body) => ({
        url: "/",
        method: "POST",
        body: {
          tckn: body.tckn,
          NextTransactionUrl: "Facebook/WebKonut/ResendOtp1",
          TokenSessionId: body.TokenSessionId
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    apply3: builder.mutation<Apply3Response, Apply3Request>({
      query: (body) => ({
        url: "/",
        method: "POST",
        body: {
          tckn: body.tckn,
          kimlikSeriSiraNo: body.kimlikSeriSiraNo,
          appCode: functionCode,
          errorCount: errorCounter,
          lockHours: lockHours,
          NextTransactionUrl: "Facebook/WebKonut/Apply3",
          TokenSessionId: body.TokenSessionId
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    apply4: builder.mutation<Apply4Response, Apply4Request>({
      query: (body) => ({
        url: "/",
        method: "POST",
        body: {
          tckn: body.tckn,
          ogrenimDurumu: body.ogrenimDurumu,
          calismaSekli: body.calismaSekli,
          meslek: body.meslek,
          isyeriFaaliyetAlani: body.isyeriFaaliyetAlani,
          unvan: body.unvan,
          aylikNetGelir: body.aylikNetGelir,
          subeKodu: body.subeKodu,
          NextTransactionUrl: "Facebook/WebKonut/Apply4",
          TokenSessionId: body.TokenSessionId
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getCities: builder.mutation<GetCitiesResponse, string>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          NextTransactionUrl: "Facebook/SocialMediaPortalStaticData/CitiesList1",
          TokenSessionId: body
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getBranches: builder.mutation<GetBranchesResponse, GetBranchesRequest>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          ilKodu: body.cityId,
          NextTransactionUrl: "Facebook/SocialMediaPortalStaticData/BranchesList1",
          TokenSessionId: body.TokenSessionId
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getEducationStatuses: builder.mutation<EducationStatusResponse, EducationStatusRequest>({
      query: (body) => ({
        url: "/",
        method: "POST",
        body: {
          NextTransactionUrl: "Facebook/SocialMediaPortalStaticData/MbbEducationList1",
          TokenSessionId: body.TokenSessionId
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getWorkTypes: builder.mutation<WorkTypeResponse, WorkTypeRequest>({
      query: (body) => ({
        url: "/",
        method: "POST",
        body: {
          education: body.education,
          NextTransactionUrl: "Facebook/SocialMediaPortalStaticData/MbbWorkTypeList1",
          TokenSessionId: body.TokenSessionId
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getOccupations: builder.mutation<OccupationResponse, OccupationRequest>({
      query: (body) => ({
        url: "/",
        method: "POST",
        body: {
          education: body.education,
          workType: body.workType,
          NextTransactionUrl: "Facebook/SocialMediaPortalStaticData/MbbOccupationList1",
          TokenSessionId: body.TokenSessionId
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getActivityAreas: builder.mutation<ActivityAreaResponse, ActivityAreaRequest>({
      query: (body) => ({
        url: "/",
        method: "POST",
        body: {
          education: body.education,
          occupation: body.occupation,
          NextTransactionUrl: "Facebook/SocialMediaPortalStaticData/MbbActivityAreaList1",
          TokenSessionId: body.TokenSessionId
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getJobTitles: builder.mutation<JobTitleResponse, JobTitleRequest>({
      query: (body) => ({
        url: "/",
        method: "POST",
        body: {
          education: body.education,
          occupation: body.occupation,
          NextTransactionUrl: "Facebook/SocialMediaPortalStaticData/MbbTitleList1",
          TokenSessionId: body.TokenSessionId
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    preApply1: builder.mutation<PreApply1Response, PreApply1Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          krediTutari: body.krediTutari,
          konutTuru: body.konutTuru,
          konutDegeri: body.konutDegeri,
          farkliKonutVarMiFlg: body.farkliKonutVarMiFlg,
          enerjiSinifi: body.enerjiSinifi,
          functionCode: functionCode,
          krediVade: body.krediVade,
          urunTipi: body.urunTipi,
          NextTransactionUrl: "Facebook/WebKonut/PreApply1",
          TokenSessionId: body.TokenSessionId
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getConfig: builder.mutation<GetConfigResponse, string>({
      query: (body) => ({
        url: "/",
        method: "POST",
        body : {
          configKey: body,
          NextTransactionUrl: "Facebook/SMPUConfig/GetConfig1",
          TokenSessionId: "ABCDEFABCDEFABCDEFABCDEFABCDEFABCDEF",
        },
      }),
      transformResponse: (response: string) => JSON.parse(response)
    })
  })
})

export const {
  useGetProductInfoMutation,
  useGetTokenByTckn1Mutation,
  useGetCaptchaMutation,
  useRefreshCaptchaMutation,
  useApply1Mutation,
  useApply2Mutation,
  useResendOtpMutation,
  useApply3Mutation,
  useApply4Mutation,
  useGetCitiesMutation,
  useGetBranchesMutation,
  useGetEducationStatusesMutation,
  useGetWorkTypesMutation,
  useGetOccupationsMutation,
  useGetActivityAreasMutation,
  useGetJobTitlesMutation,
  usePreApply1Mutation,
  useGetConfigMutation
} = api

export default api
